import React from 'react';
import { formatCurrency } from './utils';
import { useLanguage } from '../../i18n';
import ResultsBarChart from './results/ResultsBarChart';
import SystemCards from './results/SystemCards';
import ComparisonTable from './results/ComparisonTable';
import ProjectDetails from './results/ProjectDetails';
import ResultsFooter from './results/ResultsFooter';

const Step5_Results = ({ 
  calculationResult, 
  resultsRef, 
  onBack, 
  onNext, 
  onLoadInfo,
  convertToDisplayCurrency
}) => {
  const { t } = useLanguage();

  if (!calculationResult) return null;

  return (
    <div className="step-content" data-testid="step-5">
      <div ref={resultsRef} className="results-container" style={{ background: '#f5f5f5', padding: '1.5rem', paddingBottom: '2rem' }}>
        
        <h2 className="results-title" style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1B5E20', marginBottom: '0.5rem', textAlign: 'center' }}>{t('resultTitle')}</h2>
        <p style={{ fontSize: '1rem', color: '#666', marginBottom: '1.5rem', textAlign: 'center' }}>{t('resultSubtitle')}</p>
        
        <ResultsBarChart calculationResult={calculationResult} convertToDisplayCurrency={convertToDisplayCurrency} />

        {/* Savings Highlight */}
        <div style={{ 
          background: '#E8F5E9', border: '2px solid #4CAF50', borderRadius: '12px', 
          padding: '1rem 1.5rem', marginBottom: '2rem', textAlign: 'center'
        }}>
          <div style={{ fontSize: '0.95rem', color: '#1B5E20', marginBottom: '0.25rem' }}>{t('savingsTitle')}</div>
          <div style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1B5E20' }} data-testid="result-total-savings">
            {formatCurrency(convertToDisplayCurrency(calculationResult.ersparnis_vollkosten || 0), calculationResult.currency, calculationResult.display_locale)}
          </div>
        </div>

        <SystemCards calculationResult={calculationResult} convertToDisplayCurrency={convertToDisplayCurrency} />

        {/* Info Link */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <button
            onClick={onLoadInfo}
            style={{ background: 'none', border: 'none', color: '#1976D2', textDecoration: 'underline', cursor: 'pointer', fontSize: '0.95rem' }}
            data-testid="info-link"
          >
            ℹ️ {t('moreInfo')}
          </button>
        </div>

        <ComparisonTable calculationResult={calculationResult} convertToDisplayCurrency={convertToDisplayCurrency} />
        <ProjectDetails calculationResult={calculationResult} />
        <ResultsFooter />
        
      </div>

      <div className="button-group" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button onClick={onBack} className="btn-secondary" data-testid="step-5-back-btn">
          {t('back')}
        </button>
        <button onClick={onNext} className="btn-primary" data-testid="step-5-next-btn">
          {t('requestOffer')}
        </button>
      </div>
    </div>
  );
};

export default Step5_Results;
